import {Container} from './container';

export class ContainerCollection {
    private totalItems: number = 0;
    private containers: Container[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setContainers(containers: Container[]) {
        this.containers = containers;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getContainers(): Container[] {
        return this.containers;
    }
}
